import { v4 as uuidv4 } from "uuid";

const generateUUID = (prefix) => {
  const uuid = uuidv4();
  return prefix ? `${prefix}-${uuid}` : uuid;
};

export default generateUUID;
